<button
  id="share-action"
  mat-icon-button
  (click)="openOrderSharingModalWindow()"
  [appSharedRecipientTooltip]="sharedRecipientDetails"
>
  <mat-icon class="material-icons-outlined">share</mat-icon>
  @if (isOrderShared) {
  <div class="badge">
    <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
    <span>{{ contactsCount }}</span>
  </div>
  }
</button>
